export const formatPercentage = (
  decimal: number | Intl.StringNumericLiteral,
  maxFractionDigits: number = 2,
) => {
  return new Intl.NumberFormat("es-ES", {
    style: "percent",
    minimumFractionDigits: 0, // Número mínimo de decimales
    maximumFractionDigits: maxFractionDigits, // Número máximo de decimales
  }).format(decimal);
};

export const formatSeparators = (
  amount: number,
  maxFractionDigits: number = 2,
) => {
  if (amount === 0) return "0";
  const suffixes = ["", "K", "M", "B", "T"];
  // `Math.log10` is negative for |amount| < 1 (a returned unit's fractional
  // amount) and unbounded above, so the raw tier can fall outside `suffixes`
  // and append the string "undefined". Clamp it to the table.
  const tier = Math.min(
    suffixes.length - 1,
    Math.max(0, Math.floor(Math.log10(Math.abs(amount)) / 3)),
  ); // Determina la escala (K, M, B, ...)
  const scaled = amount / Math.pow(10, tier * 3); // Escalar el número
  const options: Intl.NumberFormatOptions = {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: maxFractionDigits,
  };
  return (
    new Intl.NumberFormat("es-CL", options).format(scaled) + suffixes[tier]
  );
};

export const formatNumber = (amount: number, maxFractionDigits: number = 1) => {
  const options: Intl.NumberFormatOptions = {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: maxFractionDigits,
  };
  return new Intl.NumberFormat("es-CL", options).format(amount);
};

export function ordinalNumber(numero: number) {
  const suffixes = {
    1: "er",
    2: "do",
    3: "er",
    4: "to",
    5: "to",
    6: "to",
    7: "mo",
    8: "vo",
    9: "no",
    0: "mo",
  };

  // Para números entre 11 y 19
  if (numero >= 11 && numero <= 19) {
    return numero + "avo";
  }

  // Para otros números
  const ultimoDigito = numero % 10;
  const sufijo = suffixes[ultimoDigito as keyof typeof suffixes] || "avo";

  return numero + sufijo;
}

export const percentageOfChange = (
  previous: number | null | undefined,
  current: number | null | undefined,
) => {
  if (!previous) return 0;
  return ((current || 0) - previous) / previous;
};
